<template>
    <ob1-cards class="full-height bg-primary" data-test-id="pxf-animation-card">
        <article
            class="p-1 p-md-2 text-center h-100 w-100 d-flex flex-column align-items-stretch justify-content-between background-img"
            :style="isOrange ? 'background-image: url('+ visual.src +');' : null"
        >
            <div class="mt-2 mt-md-3">
                <div class="mobile-infos navads">
                    <strong
                        v-if="title"
                        class="mb-0 font-size-25"
                        :class="isOrange ? 'text-primary2' : 'text-white'"
                        v-html="title"
                    />
                    <div v-if="subTitle" class="h3 mb-0 text-white" v-html="subTitle" />
                </div>
                <p v-if="text" class="lead mb-0 infos-price navads mt--1 text-white pt-2" v-html="text" />
            </div>
            <div class="px-1 infos-advantage navads" />
            <div class="pt-1 d-webview-none">
                <ob1-boutons
                    v-if="url !== undefined && urlAccessWording !== undefined"
                    id="tile-button"
                    class="pb-1 mx-auto"
                    :is-primary="true"
                    :is-button="false"
                    :is-inverse="isOrange"
                    :label="urlAccessWording"
                    :href="url"
                    target="_blank"
                    data-oevent-category="profitez_du_paiement_en_12_24_36_48_des_200_euros_d_achat"
                    data-oevent-action="en_savoir_plus"
                    :data-oevent-label="url"
                />
            </div>
        </article>
    </ob1-cards>
</template>

<script>

export default {
    name: "PxfAnimationCard",
    props: {
        isOrange: {
            type: Boolean,
            required: false
        },
        title: {
            type: String,
            default: undefined
        },
        subTitle: {
            type: String,
            default: undefined
        },
        text: {
            type: String,
            default: undefined
        },
        urlAccessWording: {
            type: String,
            default: undefined
        },
        url: {
            type: String,
            default: undefined
        },
        visual: {
            type: Object,
            default: undefined
        }
    }
}
</script>
<style scoped lang="scss">
.background-img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
